import { SectionHeader } from "@/theme1/components/common/SectionHeader";
import RecommendationCarousel from "@/theme1/components/recommendations/RecommendationCarousel";

export default function RelatedProducts({ products }) {
  return (
    <section className="space-y-8">
      <SectionHeader
        eyebrow="Related Products"
        title="Complete the look."
        description="Premium products selected around the same design language."
      />
      <RecommendationCarousel products={products} />
    </section>
  );
}